module.exports = __webpack_public_path__ + "img/step4b-en@2x.01110573.webp";